export function FormatStatus(code) {
  switch (code) {
    case 103:
      return "Approved By HOD Finance";
    case 0:
      return "Approved";
    case 20:
      return "ApprovedByHR";
    case 40:
      return "ApprovedByHOU";
    case 50:
      return "ApprovedByHOD";
    case 30:
      return "ApprovedByEDO";
    case 60:
      return "ApprovedByEDFI";
    case 10:
      return "ApprovedByMD";
    case 81:
      return "RejectedByHR";
    case 729:
      return "RejectedByHOU";
    case 243:
      return "RejectedByHOD";
    case 9:
      return "RejectedByEDO";
    case 27:
      return "RejectedByEDFI";
    case 3:
      return "RejectedByMD";
    case 1:
      return "Pending";
    case 7:
      return "Declined";
    case 11:
      return "Cancelled";
    case 13:
      return "Paid";
    case 17:
      return "Draft";
    case 14:
      return "Retired";
    case 2:
      return "Closed";
    case 16:
      return "Authorized";
    case 29:
      return "MakePayment";
    case 39:
      return "DeclinePayment";
    case 100:
      return "Terminated";
    case 101:
      return "Awaiting Control Review";
    case 102:
      return "Awaiting Control Approval";
    case 104:
      return "Reviewed By Control";
    case 106:
      return "Reviewed By Control 2";
    default:
      return "Unknown";
  }
}

export function FormatStatusA(code) {
  switch (code) {
    case 0:
      return "InActive";
    case 1:
      return "Active";
    case 2:
      return "UnderMaintenance";
    default:
      return "Unknown";
  }
}

export function getColorByStatusA(status) {
  switch (status) {
    case 1: // Approved
      return { color: "#FFFFFF", backgroundColor: "#0F6308" }; // White text, Green background
    case 0: // Declined
      return { color: "#FFFFFF", backgroundColor: "#8A002B" }; // White text, Red background
    case 2: // Terminated
      return { color: "#FFFFFF", backgroundColor: "#FF0000" }; // White text, Bright Red background
    default:
      return { color: "#000000", backgroundColor: "#808080" }; // Black text, Grey background for Unknown
  }
}

// Color and Background Scheme Function
export function getColorByStatus(status) {
  switch (status) {
    case 0: // Approved
    case 103: // Approved by Control
      return { color: "#FFFFFF", backgroundColor: "#0F6308" }; // White text, Green background
    case 1: // Pending
    case 101: // Awaiting Control Review
    case 102: // Awaiting Control Approval
      return { color: "#000000", backgroundColor: "#FFD700" }; // Black text, Yellow background
    case 7: // Declined
    case 104: // Rejected by Control
    case 81: // Rejected by HR
    case 729: // Rejected by HOU
    case 243: // Rejected by HOD
    case 9: // Rejected by EDO
    case 27: // Rejected by EDFI
    case 3: // Rejected by MD
      return { color: "#FFFFFF", backgroundColor: "#8A002B" }; // White text, Red background
    case 11: // Cancelled
    case 17: // Draft
      return { color: "#FFFFFF", backgroundColor: "#815103" }; // White text, Brown background
    case 14: // Retired
    case 13: // Paid
    case 16: // Authorized
      return { color: "#FFFFFF", backgroundColor: "#0066cc" }; // White text, Blue background
    case 100: // Terminated
      return { color: "#FFFFFF", backgroundColor: "#FF0000" }; // White text, Bright Red background
    default:
      return { color: "#000000", backgroundColor: "#808080" }; // Black text, Grey background for Unknown
  }
}
